// src/pages/auth/pages/TermsPopup.jsx
import React, { useEffect } from "react";
import ReactDOM from "react-dom";

const TermsPopup = ({ onClose, onAgree }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[999] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/50 animate-fade-in"
        onClick={onClose}
      />
      <div
        className="relative bg-white rounded-lg w-[92%] max-w-xl p-6 animate-scale-in shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Điều khoản dịch vụ"
      >
        <div className="mb-4 flex items-center justify-between border-b pb-2">
          <h2 className="text-xl font-bold">Điều khoản dịch vụ</h2>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
            aria-label="Đóng"
          >
            <img alt="Close icon" src="/icons/x-close.svg" />
          </button>
        </div>

        <p className="text-sm text-gray-700 mb-4 max-h-[60vh] overflow-auto">
          Đây là các điều khoản dịch vụ. Bằng cách sử dụng ứng dụng này, bạn
          đồng ý tuân theo các điều khoản được nêu rõ...
        </p>

        <div className="flex justify-end">
          <button
            onClick={() => {
              onAgree?.();
              onClose?.();
            }}
            className="text-white bg-blue-500 hover:bg-blue-600 py-2 px-4 rounded-lg shadow transition-all active:scale-[0.98]"
          >
            Tôi đồng ý điều khoản & dịch vụ
          </button>
        </div>
      </div>

      <style>{`
        .animate-fade-in { animation: fadeIn .25s ease-out forwards; }
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        .animate-scale-in { animation: scaleIn .28s cubic-bezier(0.2,0,0,1) forwards; }
        @keyframes scaleIn {
          from { opacity: 0; transform: translateY(6px) scale(0.98); }
          to   { opacity: 1; transform: translateY(0)   scale(1); }
        }
      `}</style>
    </div>,
    document.body
  );
};

export default TermsPopup;
